import React, { useState }  from "react";
import { connect } from "react-redux";
import SummaryCard from "components/widget/SummaryCard";
import { LucideCalendar, LucideCircleCheck, LucideCircleX, LucideClock } from "lucide-react";
import WeeklyAttendanceOverview from "./components/WeeklyAttendanceOverview";
import CalendarView from "./components/CalendarView";
import { getAttendanceSummary } from "../../../redux/overview/overviewState";
import EmployeeAttendanceTable from "./components/EmployeeAttendanceTable";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const { MonthPicker } = DatePicker;
const AttendanceOverview = ({recordList}) => {
	
	const [selectedMonth, setSelectedMonth] = useState(dayjs());

	const startDate = selectedMonth.startOf("month").format("YYYY-MM-DD");
	const endDate = selectedMonth.endOf("month").format("YYYY-MM-DD");

	const handleMonthChange = (date) => {
		if (!date) return;
		setSelectedMonth(date);
	};

	return (
		<div>
			<div className="inline-flex mt-4">
				<MonthPicker
				 	className="w-[150px]"
					onChange={handleMonthChange}
					defaultValue={dayjs()}
					format="MMMM YYYY"
					placeholder="Select month"
				/>
			</div>
			<div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 3xl:grid-cols-4">
				<SummaryCard
					title={"Total Present"}
					icon={<LucideCircleCheck size={16} className="text-green-600"/>}
					displayCount={recordList?.total_present_days}
					description={"Days this month"}
					textColor="text-green-600"
				/>	

				<SummaryCard
					title={"Total Absent"}
					icon={<LucideCircleX size={16} className="text-red-600"/>}
					displayCount={recordList?.total_absent_days}
					description={"Days this month"}
					textColor="text-red-600"
				/>
				<SummaryCard
					title={"Late Arrivals"}
					icon={<LucideClock size={16} className="text-orange-600"/>}
					displayCount={recordList?.total_late_days}
					description={"Instances this month"}
					textColor="text-orange-600"
				/>		
				<SummaryCard
					title={"Avg. Attendance"}
					icon={<LucideCalendar size={16} className="text-black-600"/>}
					displayCount={`${recordList?.attendance_rate}%`}
					description={"This month"}
					textColor="text-black-600"
				/>

			</div>
			<div className="grid grid-cols-3 gap-4 mt-6">
				<div className="col-span-2">
					<WeeklyAttendanceOverview/>
				</div>
				<div>
					<CalendarView/>
				</div>
			</div>
			<div className="mt-6">
      			<EmployeeAttendanceTable 
					date={selectedMonth}
					startDate={startDate} 
					endDate={endDate} />
			</div>
		</div>
    );
};

const mapStateToProps = (state) => ({
  recordList: state.overview.employeeAttendanceRecord?.data?.totals,
  requesting: state.overview.employeeAttendanceRecord?.requesting,
  error: state.overview.employeeAttendanceRecord?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getAttendanceSummary(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps) (AttendanceOverview);